import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import { S } from '../state.js';

export const I18N = { en, de, fr };

export function t(k,vars){
  let s=(I18N[S.settings.lang]&&I18N[S.settings.lang][k])||I18N.en[k]||k;
  if(vars)for(const v in vars)s=s.split('{'+v+'}').join(vars[v]);
  return s;
}
